module.exports = __webpack_public_path__ + "img/xueshengduan.f6660eb1.png";